module.exports = __webpack_public_path__ + "media/warbling-vireo-2.aee7e2b6.mp3";